@if (!isLoading()) {
    <medpace-page>
        <div class="flex flex-col gap-medpace items-center">
            @if (!guid() || !invitation()) {
                <medpace-alert [content]="errorMessage()" appearance="highlight" />
            } @else {
                <mds-card [appearance]="'elevated'">
                    <mds-card-content>
                        <div class="o-grid__row">
                            <div class="o-grid__item">
                                <h3 class="text-center">CRC Invitation</h3>
                            </div>
                        </div>
                        <div class="o-grid__row">
                            <div class="o-grid__item"><h4>Click here to register for a new account:</h4></div>
                        </div>
                        <div class="o-grid">
                            <div class="o-grid__row">
                                <div class="o-grid__item margin-bottom-0">
                                    <mds-button
                                        width="100%"
                                        label="Register"
                                        color="primary"
                                        [variant]="'tonal'"
                                        [id]="'registerBtn'"
                                        (clickEvent)="register()"
                                    />
                                </div>
                            </div>
                            <div class="o-grid__row">
                                <div class="o-grid__item">
                                    <h4>Already a {{ applicationName }} User? Click here to sign in:</h4>
                                </div>
                            </div>
                            <div class="o-grid__row">
                                <div class="o-grid__item margin-bottom-0">
                                    <mds-button
                                        width="100%"
                                        label="Sign in"
                                        color="primary"
                                        [variant]="'tonal'"
                                        [id]="'signInBtn'"
                                        (clickEvent)="signIn()"
                                    />
                                </div>
                            </div>
                        </div>
                    </mds-card-content>
                </mds-card>
            }
        </div>
    </medpace-page>
}

@if (isLoading()) {
    <medpace-loading />
}
